import { inject } from "aurelia-framework";
import { HttpClient } from "aurelia-http-client";
import { CookieHelper } from "services/cookieHelper";
@inject(HttpClient, CookieHelper)
export class ChatBotAPI {
  constructor(http, cookieHelper) {
    this.http = http;
    this.cookie = cookieHelper;
    console.log("ChatBotAPI Initialized:", this.http);
  }

  getChatbotDetail(token, successCallback, errorCallback) {
      console.log("🚀 getChatbotDetail called with token: ", token);
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    this.http.get("api/account/chatbot/getChatbotDetail").then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);
        if (json.hasOwnProperty("chatbotDetail")) successCallback(json.chatbotDetail);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }
  save(data, token, successCallback, errorCallback) {
    console.log("data in save", data);
    var formData = new FormData();
    formData.append("chatbot", JSON.stringify(data));
    var http = new HttpClient().configure((x) => {
      x.withHeader("Authorization", token);
    });

    http.post("api/account/chatbot/save", formData).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("chatbot")) successCallback(json.chatbot);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }
}
